import type { ForUserError } from './errors-translator';

export type KorintAPIError = {
  status: number;
  // Flat payload; re-tighten from kubb's *ErrorDto types if per-code `details` typing is needed.
  payload: {
    code: string;
    message?: string;
    details: any;
  };
};

type KorintErrorResponse = {
  data: KorintAPIError['payload'];
  status: number;
};

// Must stay a real Error: a thrown plain object reaches PostHog with no message and no stack.
export class KorintRequestError extends Error implements ForUserError {
  readonly userError: string;
  readonly userHelp: string;
  readonly response?: Record<string, unknown>;
  readonly errorResponse?: KorintErrorResponse;

  constructor(forUser: ForUserError, errorResponse?: KorintErrorResponse) {
    super(`Request failed with status ${errorResponse?.status ?? 'unknown'}`);
    this.name = 'KorintRequestError';
    this.userError = forUser.userError;
    this.userHelp = forUser.userHelp;
    this.response = forUser.response;
    this.errorResponse = errorResponse;
  }
}

export function getKorintErrorCode(error: unknown): string | undefined {
  return (error as { errorResponse?: { data?: { code?: string } } })?.errorResponse?.data?.code;
}

export function getKorintErrorStatus(error: unknown): number | undefined {
  return (error as { errorResponse?: { status?: number } })?.errorResponse?.status;
}

export function getKorintErrorDetails(error: unknown): KorintAPIError['payload']['details'] {
  return (error as { errorResponse?: KorintErrorResponse })?.errorResponse?.data?.details;
}
